import React, { Component } from 'react';
import { Paper, ButtonBase } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { withRouter } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse/Collapse';

class GoBackBar extends Component {
  handleClick = () => {
    const { history } = this.props;
    const path = history.location.pathname.split('/');
    const s = path.slice(0, path.length - 1).join('/');
    history.replace(s);
  }

  render() {
    const { classes, location: { pathname } } = this.props;
    const isActive = pathname !== '/';
    return (
      <Collapse in={isActive}>
        <Paper elevation={0} className={classes.container}>
          <div className={classes.body}>
            <div className={classes.bodycontent}>
              <ButtonBase
                tabIndex={isActive ? 0 : -1}
                focusRipple
                onClick={this.handleClick}
                className={classes.goBackButton}
              >
                <ArrowBack />
                <Typography className={classes.text} color="inherit" variant="body1">
                  Tilbake
                </Typography>
              </ButtonBase>
            </div>
          </div>
        </Paper>
      </Collapse>
    );
  }
}

const styles = theme => ({
  container: {
    minWidth: '20rem',
    backgroundColor: theme.palette.secondary.main,
    borderBottom: '0.0625rem solid #cccccc',
  },
  body: {
    width: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginLeft: theme.containerMarginBase(),
  },
  bodycontent: {
    margin: 'auto',
    maxWidth: '68.5rem',
    display: 'flex',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  goBackButton: {
    borderRadius: '0.25rem',
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  text: {
    paddingLeft: '0.8rem',
  },
});

GoBackBar.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(GoBackBar));
